import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatSnackBar } from '@angular/material';
import { DeliveriesService } from 'src/app/services/deliveries.service';
import { OrdersService } from 'src/app/services/orders.service';
import { MetaService } from 'src/app/services/meta.service';

import * as moment from 'moment';

@Component({
  selector: 'app-dialog-update-single-delivery-date',
  templateUrl: './dialog-update-single-delivery-date.component.html',
  styleUrls: ['./dialog-update-single-delivery-date.component.css']
})
export class DialogUpdateSingleDeliveryDateComponent implements OnInit {

  public deliveryDate: any = '';
  deliveryDays = [];

  myFilter = (d: Date | null): boolean => {

    const day = (d || new Date()).getDay();
    const date = (d || new Date()).getDate();
    const todayDate = new Date().getDate();

    let days = this.deliveryDays;


    if (days.length == 1) {
      return day !== days[0] && date !== todayDate;
    }

    if (days.length == 2) {
      return day !== days[0] && day !== days[1] && date !== todayDate;
    }

    if (days.length == 3) {
      return day !== days[0] && day !== days[1] && day !== days[2] && date !== todayDate;
    }

    if (days.length == 4) {
      return day !== days[0] && day !== days[1] && day !== days[2] && day !== days[3] && date !== todayDate;
    }

    if (days.length == 5) {
      return day !== days[0] && day !== days[1] && day !== days[2] && day !== days[3] && day !== days[4] && date !== todayDate;
    }

    if (days.length == 6) {
      return day !== days[0] && day !== days[1] && day !== days[2] && day !== days[3] && day !== days[4] && day !== days[5] && date !== todayDate;
    }

    if (days.length == 7) {
      return day !== days[0] && day !== days[1] && day !== days[2] && day !== days[3] && day !== days[4] && day !== days[5] && day !== days[6] && date !== todayDate;
    }
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private deliveriesSerivice: DeliveriesService, private ordersService: OrdersService, private META_DATA: MetaService, private dialog: MatDialog, private snackBar: MatSnackBar) { }

  ngOnInit() {

    this.META_DATA.getMetaData().subscribe(result => {
      if (result.success) {
        this.deliveryDays = result.data.invalidDeliveryDays;
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });

    this.deliveryDate = this.data.deliveryDate;

    const splitDate = this.data.deliveryDate.split('-');
    this.deliveryDate = `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;

  }

  onUpdate() {
    const data = new FormData();
    data.append('_id', this.data.deliveryID);
    data.append('deliveryDate', moment(this.deliveryDate).format('DD-MM-YYYY'));

    this.deliveriesSerivice.updateSingleDeliveryDateAsAUser(data).subscribe(result => {
      if (result.success) {
        this.ordersService.getAllOrders({ status: "Pending" }).subscribe(result => {
          this.ordersService.setOrders(result.data);
          this.dialog.closeAll();
          this.snackBar.open('Delivery dates updated successfully', 'Dismiss', {
            duration: 3000
          });
        });
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 30000
      });
    });
  }
}
